import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Cards from './Cards.jsx';
import options from '../data/options.json';
import unpackCourses from '../functions/unpackCourses';

let unpacked = false;

const SchoolCourseList = (props) => {
    const [filter, setFilter] = useState('all');

    if (!unpacked) {
        unpackCourses(props.courses, window.mainCategories, props.schools);
        unpacked = true;
    }

    const filteredCourses = filter === 'all'
        ? props.courses
        : props.courses.filter(course => course.coursetype === filter);

    const month = (new Date()).getMonth();
    const showAutumnFirst = (month >= 2 && month <= 9);

    const halfYearButtons = showAutumnFirst ? [
        { type: 'hh', labelLarge: 'Halvårslinjer høst', labelSmall: 'Halvår høst' },
        { type: 'hv', labelLarge: 'Halvårslinjer vår', labelSmall: 'Halvår vår' }
    ] : [
        { type: 'hv', labelLarge: 'Halvårslinjer vår', labelSmall: 'Halvår vår' },
        { type: 'hh', labelLarge: 'Halvårslinjer høst', labelSmall: 'Halvår høst' }
    ];

    const onlyFullYear = props.courses.every(c => c.coursetype === 'w');

    return (
        <>
            {!onlyFullYear && <div className="card__school-course-filters">
                <button onClick={() => setFilter('all')} className={`button button__filter ${filter === 'all' ? 'button__filter--selected' : ''}`}>
                    <span class="button__filter--large">Alle linjer</span>
                    <span class="button__filter--small">Alle</span>
                </button>
                <button onClick={() => setFilter('w')} className={`button button__filter ${filter === 'w' ? 'button__filter--selected' : ''}`}>
                    <span class="button__filter--large">Helårslinjer</span>
                    <span class="button__filter--small">Helårs</span>
                </button>
                {halfYearButtons.filter(btn => props.courses.some(c => c.coursetype === btn.type)).map(btn => (
                    <button key={btn.type} onClick={() => setFilter(btn.type)} className={`button button__filter ${filter === btn.type ? 'button__filter--selected' : ''}`}>
                        <span class="button__filter--large">{btn.labelLarge}</span>
                        <span class="button__filter--small">{btn.labelSmall}</span>
                    </button>
                ))}
            </div>}
            <Cards courses={filteredCourses} prices={options.courses.price} lang={props.lang} standalone={false} limit={props.limit} total={filteredCourses.length} />
        </>
    );
};

SchoolCourseList.propTypes = {
    courses: PropTypes.array,
    schools: PropTypes.array,
    lang: PropTypes.string,
    limit: PropTypes.number
};

export default SchoolCourseList;
